// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const houndoom: PokeData = {
  "id": 229,
  "name": "houndoom",
  "height": 14,
  "weight": 350,
  "base_experience": 175,
  "types": [
    PokeType.DARK,
    PokeType.FIRE
  ],
  "api_moves": [
    "leer",
    "bite",
    "roar",
    "ember",
    "flamethrower",
    "smog",
    "feint-attack",
    "crunch",
    "beat-up",
    "torment",
    "taunt",
    "odor-sleuth",
    "howl",
    "payback",
    "embargo",
    "nasty-plot",
    "thunder-fang",
    "fire-fang",
    "flame-charge",
    "foul-play",
    "incinerate",
    "inferno",
    "comeuppance"
  ],
  "moves": [
    "leer",
    "bite",
    "ember",
    "flamethrower",
    "crunch",
    "thunder-fang",
    "fire-fang",
    "morning-sun",
    "dark-bargain",
    "lash-out",
    "fire-ball",
    "phantom-force",
    "pursuit"
  ],
  "evolution_chain": {
    "id": 118,
    "item": null,
    "species": [
      {
        "name": "houndour",
        "order": 261,
        "types": [
          PokeType.DARK,
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "houndoom",
        "order": 262,
        "types": [
          PokeType.DARK,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 228,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 102,
    "speed": 138,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
